import axios from '../../axios'

/*
 * 个人中心管理模块
 */


export const save = (data) => {
  return axios({
    url: '/system/password/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/personCenter.js